import _ from 'underscore';
import { getDefaultValue } from './default-value';
import { createValidation } from './validation/index';
import { createConversion } from './conversion/index';

/**
 * Viewmodel schema field
 * @param {Object} prop - schema property bag
 * @param {I18n} i18n - provide callback getString to get localized string
 * @param {Object} override - Optional override object that changes auto-generated fields
 */
export class Field {
  constructor(prop, i18n, override) {
    this.prop = prop;
    this.i18n = i18n;
    this.override = override;
  }

  /**
   * Get default value generated from schema
   * @returns {Object} - default value
   */
  get default() {
    let defaultValue = getDefaultValue(this.prop);

    if (this.override && _.isFunction(this.override.default)) {
      defaultValue = this.override.default(defaultValue);
    }

    return defaultValue;
  }

  /**
   * Get validation rules generated from schema
   * @returns {Object} - validation rules
   */
  get validation() {
    let validation = createValidation(this.prop, this.i18n);

    if (this.override && _.isFunction(this.override.validation)) {
      validation = this.override.validation(validation);
    }

    return validation;
  }

  /**
   * Get conversions generated from schema
   * @returns {Object} - object that handles fromModel and toModel conversion
   */
  get conversion() {
    let conversion = createConversion(this.prop, this.i18n);

    if (this.override && _.isFunction(this.override.conversion)) {
      conversion = this.override.conversion(conversion);
    }

    return conversion;
  }
}
